export default __webpack_public_path__ + "static/media/ex.75c21c6f.jpg";